<script lang="ts" setup>
import { Category } from '@/helper/Types.ts'
import { computed } from 'vue'
import CounterBadge from '@/components/badges/CounterBadge.vue'

const emit = defineEmits<{
  (e: 'update:modelValue', val: string): void
}>()

const props = defineProps<{
  validate?: () => Promise<boolean>
  categories: Category[]
  modelValue?: Category['label']
}>()

const totalCount = computed(() => props.categories.reduce((acc, cat) => acc + (cat.count || 0), 0))

async function onCategoryClick(label: string) {
  if (!props.validate || await props.validate()) {
    emit('update:modelValue', label)
  }
}
</script>

<template>
  <div class="card accessories-filter-bar">
    <button
      :class="{ 'is--tertiary': modelValue === 'all' }"
      :title="$t('step_accessories.filter.all')"
      class="btn has-outline is--secondary"
      @click="onCategoryClick('all')"
    >
      {{ $t('step_accessories.filter.all') }}
      <CounterBadge v-if="totalCount" :count="totalCount" />
    </button>

    <button
      v-for="category in categories"
      :key="category.label"
      :class="{ 'is--tertiary': modelValue === category.label }"
      :title="$t(`step_accessories.group_${category.label}`)"
      class="btn has-outline is--secondary"
      @click="onCategoryClick(category.label)"
    >
      <span class="label">{{ $t(`step_accessories.group_${category.label}`) }}</span>
      <CounterBadge v-if="category.count" :count="category.count" />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.accessories-filter-bar {
  padding: rem-calc(16);
  display: flex;
  width: fit-content;
  gap: rem-calc(16);
  margin: 0 auto;
  flex-wrap: wrap;

  .btn {
    min-width: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: rem-calc(4);

    @include themify($themes) {
      border-radius: rem-calc(themed('btnSubNavBorderRadius'));
    }

    .label {
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 125px;
      white-space: nowrap;
    }
  }
}
</style>
